import React from "react";
import EditingSettingsTable from "./editingSettingsTable";
import CenteredDots from "../General/centeredDots";
import Button from "../button";
import {scrollToElement} from "../../helpers/functions";
import FormResponseMessage from "../formResponseMessage";

const EditingSettings = (props) => {
    const {
        questions,
        editingSettings,
        editingSettingsValues,
        changeEditingSettings,
        editingSettingsOptions,
        fetchingQuestions,
        getQuestionFromEditingSetting,
        getFieldFormEditingSetting,
        getEditingSettingFromQuestionId,
        handleSaveChanges,
        fetchingEditingSettingsEditableByOptions,
        fetchingEditingSettings,
        updating,
        updateErrorMessage,
        updateSuccessMessage,
        getEditingSettingFromTableName
    } = props;
    const isLoading = (
        fetchingEditingSettingsEditableByOptions
        || fetchingEditingSettings
        || fetchingQuestions
    );
    let wrapperEl = null;

    return (
        <div ref={(el) => { wrapperEl = el; }} >
            <h2 className="applicationsAndPolicies-h2">Editing Settings</h2>
            {updating && (
                <div className={"col-sm-12"}>
                    <CenteredDots/>
                </div>
            )}
            {updateErrorMessage && (
                <div className={"form-horizontal"}>
                    <FormResponseMessage
                        Message={updateErrorMessage}
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-reject"
                    />
                </div>
            )}
            {updateSuccessMessage && (
                <div className={"form-horizontal"}>
                    <FormResponseMessage
                        Message={updateSuccessMessage}
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-success"
                    />
                </div>
            )}
            {
                isLoading ?
                    <div className={"col-sm-12"}>
                        <CenteredDots/>
                    </div>
                    :
                    <div>
                        <EditingSettingsTable
                            questions={questions}
                            editingSettings={editingSettings}
                            editingSettingsValues={editingSettingsValues}
                            changeEditingSettings={changeEditingSettings}
                            editingSettingsOptions={editingSettingsOptions}
                            getQuestionFromEditingSetting={getQuestionFromEditingSetting}
                            getFieldFormEditingSetting={getFieldFormEditingSetting}
                            getEditingSettingFromQuestionId={getEditingSettingFromQuestionId}
                            getEditingSettingFromTableName={getEditingSettingFromTableName}
                        />
                        <Button
                            clickHandler={() => {
                                if(wrapperEl){
                                    scrollToElement(wrapperEl, {left: 0, top: wrapperEl.offsetTop});
                                }

                                handleSaveChanges();
                            }}
                            wrapper="btn-fab"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Save Changes"
                        />
                    </div>
            }
        </div>
    )
};

export default EditingSettings;